/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAlertcallsDashboardStatsGet } from '../fn/alertcalls/api-alertcalls-dashboard-stats-get';
import { ApiAlertcallsDashboardStatsGet$Params } from '../fn/alertcalls/api-alertcalls-dashboard-stats-get';
import { apiAlertcallsGet } from '../fn/alertcalls/api-alertcalls-get';
import { ApiAlertcallsGet$Params } from '../fn/alertcalls/api-alertcalls-get';
import { apiAlertcallsIdAnswersGet } from '../fn/alertcalls/api-alertcalls-id-answers-get';
import { ApiAlertcallsIdAnswersGet$Params } from '../fn/alertcalls/api-alertcalls-id-answers-get';
import { MultipleReturnGetAlertCallAnswersDto } from '../models/multiple-return-get-alert-call-answers-dto';
import { MultipleReturnGetAlertCallsDto } from '../models/multiple-return-get-alert-calls-dto';
import { SingleReturnGetAlertCallDashboardStatsDto } from '../models/single-return-get-alert-call-dashboard-stats-dto';

@Injectable({ providedIn: 'root' })
export class AlertcallsService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /** Path part for operation `apiAlertcallsGet()` */
    static readonly ApiAlertcallsGetPath = '/api/alertcalls';

    /**
     * Retrieve all alert calls with optional filters and additional data.
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `apiAlertcallsGet()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiAlertcallsGet$Response(
        params?: ApiAlertcallsGet$Params,
        context?: HttpContext,
    ): Observable<StrictHttpResponse<MultipleReturnGetAlertCallsDto>> {
        return apiAlertcallsGet(this.http, this.rootUrl, params, context);
    }

    /**
     * Retrieve all alert calls with optional filters and additional data.
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `apiAlertcallsGet$Response()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiAlertcallsGet(params?: ApiAlertcallsGet$Params, context?: HttpContext): Observable<MultipleReturnGetAlertCallsDto> {
        return this.apiAlertcallsGet$Response(params, context).pipe(
            map((r: StrictHttpResponse<MultipleReturnGetAlertCallsDto>): MultipleReturnGetAlertCallsDto => r.body),
        );
    }

    /** Path part for operation `apiAlertcallsIdAnswersGet()` */
    static readonly ApiAlertcallsIdAnswersGetPath = '/api/alertcalls/{id}/answers';

    /**
     * Get all answers of an alertcall.
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `apiAlertcallsIdAnswersGet()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiAlertcallsIdAnswersGet$Response(
        params: ApiAlertcallsIdAnswersGet$Params,
        context?: HttpContext,
    ): Observable<StrictHttpResponse<MultipleReturnGetAlertCallAnswersDto>> {
        return apiAlertcallsIdAnswersGet(this.http, this.rootUrl, params, context);
    }

    /**
     * Get all answers of an alertcall.
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `apiAlertcallsIdAnswersGet$Response()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiAlertcallsIdAnswersGet(
        params: ApiAlertcallsIdAnswersGet$Params,
        context?: HttpContext,
    ): Observable<MultipleReturnGetAlertCallAnswersDto> {
        return this.apiAlertcallsIdAnswersGet$Response(params, context).pipe(
            map((r: StrictHttpResponse<MultipleReturnGetAlertCallAnswersDto>): MultipleReturnGetAlertCallAnswersDto => r.body),
        );
    }

    /** Path part for operation `apiAlertcallsDashboardStatsGet()` */
    static readonly ApiAlertcallsDashboardStatsGetPath = '/api/alertcalls/dashboard/stats';

    /**
     * Get the stats of alertcalls, for the dashboard.
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `apiAlertcallsDashboardStatsGet()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiAlertcallsDashboardStatsGet$Response(
        params?: ApiAlertcallsDashboardStatsGet$Params,
        context?: HttpContext,
    ): Observable<StrictHttpResponse<SingleReturnGetAlertCallDashboardStatsDto>> {
        return apiAlertcallsDashboardStatsGet(this.http, this.rootUrl, params, context);
    }

    /**
     * Get the stats of alertcalls, for the dashboard.
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `apiAlertcallsDashboardStatsGet$Response()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiAlertcallsDashboardStatsGet(
        params?: ApiAlertcallsDashboardStatsGet$Params,
        context?: HttpContext,
    ): Observable<SingleReturnGetAlertCallDashboardStatsDto> {
        return this.apiAlertcallsDashboardStatsGet$Response(params, context).pipe(
            map((r: StrictHttpResponse<SingleReturnGetAlertCallDashboardStatsDto>): SingleReturnGetAlertCallDashboardStatsDto => r.body),
        );
    }
}
